module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/repertorio_pic.25f567ae.png";